export enum SidebarTranslationKeys {
  MY_LOADS_SECTION_LABEL = 'sidebar.sections.myLoads.label',
  MY_LOADS_SECTION_PREPARED = 'sidebar.sections.myLoads.prepared',
  MY_LOADS_SECTION_OPEN = 'sidebar.sections.myLoads.open',
  MY_LOADS_SECTION_ASSIGNABLE = 'sidebar.sections.myLoads.assignable',
  MY_LOADS_SECTION_SEARCH_CNX_SHIPMENTS = 'sidebar.sections.myLoads.searchCNXShipments',
  MY_DATA_SECTION_LABEL = 'sidebar.sections.myData.label',
  MY_DATA_SECTION_DATA_INTEGRATION = 'sidebar.sections.myData.dataIntegration',
  MY_DATA_SECTION_CARRIER_NETWORK = 'sidebar.sections.myData.carrierNetwork',
  MY_DATA_SECTION_RATE_MANAGEMENT = 'sidebar.sections.myData.rateManagement',
  MY_DATA_SECTION_LOCATIONS = 'sidebar.sections.myData.locations',
  MY_DATA_SECTION_LOADS = 'sidebar.sections.myData.loads',
  MY_DATA_SECTION_VEHICLES = 'sidebar.sections.myData.vehicles',
  MY_TOUR_PLANNER_SECTION_LABEL = 'sidebar.sections.myTourPlanner.label',
  TOUR_PLANNER_SECTION = 'sidebar.sections.tourPlanner',
  PATH_TOUR_PLANNER_CONFIGURATIONS = 'sidebar.sections.tourPlannerSettings',
  MY_SHIPMENTS_SECTION_LABEL = 'sidebar.sections.myShipments.label',
  MY_SHIPMENTS_SECTION_SHIPMENT_EXECUTION = 'sidebar.sections.myShipments.shipmentExecution',
  OVERVIEW_SECTION_LABEL = 'sidebar.sections.overview.label',
  OVERVIEW_SECTION_DASHBOARD = 'sidebar.sections.overview.dashboard',
  OVERVIEW_ANALYTICS = 'sidebar.sections.overview.analytics',
  LOGOUT = 'sidebar.logout',
  MY_SHIPMENTS_SECTION_DATA_EXPORT = 'sidebar.sections.myShipments.dataExport',
  ORDERS_SECTION_LABEL = 'sidebar.sections.orders.label',
  PATH_ARTICLES = 'sidebar.sections.orders.articles',
  PRIVACY_SETTINGS = 'sidebar.sections.privacySettings',
  USER_MANAGEMENT = 'sidebar.sections.userManagement',
}
